<template>
  <div>
    <!-- ============= If not admin -->
    <div v-if="!((user as User)?.is_admin ?? false)" class="flex flex-col h-full gap-4 p-8">
      <h3 v-text="t('supportchat.requestsupport.title')"/>
      <div v-html="t('supportchat.requestsupport.text')"/>
      <div v-if="dataSupportLastOnlineInMinutes !== null">
        <span v-if="dataSupportLastOnlineInMinutes <= 1" class="text-green-600 font-bold" v-text="t('supportchat.requestsupport.supportonline')"/>
        <span v-else-if="dataSupportLastOnlineInMinutes <= 30" class="text-yellow-600 font-bold" v-text="t('supportchat.requestsupport.supportjusthere')"/>
        <span v-else-if="dataSupportLastOnlineInMinutes < 60" class="text-yellow-600 font-bold" v-text="t('supportchat.requestsupport.supportthishour')"/>
        <span v-else class="text-slate-400 font-bold" v-text="t('supportchat.requestsupport.supportlongtime', {hours: Math.floor(dataSupportLastOnlineInMinutes/60)})"/>
      </div>

      <div class="flex flex-col items-center gap-4">
        <ui-button
          :text="t('supportchat.requestsupport.talktohuman')"
          svg="fa fa-user"
          class="dark w-full"
          @click="methodTalkToHuman()"
          />
        <ui-button
          :text="t('supportchat.requestsupport.talktobot')"
          svg="fa fa-robot"
          class="dark w-full"
          disabled
          />
        <span v-text="t('or')"/>
        <ui-button
          :text="t('supportchat.requestsupport.reportbug')"
          class="dark w-full flat"
          @click="dataShowBugReport = true; modelPopup = false"
          />
      </div>
    </div>

    <!-- ============= If admin -->
    <div v-else class="space-y-2 p-4">
      <ui-button
        text="Reload session"
        svg="fa fa-arrows-rotate"
        class="dark w-full"
        @click="methodShowOpenSessions()"
        />

      <div v-if="dataSessions?.length" class="space-y-2 h-96 max-h-[60vh] overflow-y-auto">
        <UniqueSupportOpenSessionButton
          v-for="session in dataSessions"
          :key="session.session"
          :session="session.session"
          :latest-message="session.message"
          :latest-updated="session.created_at"
          :unread_count="session.unread_count"
          @click="modelSession = session.session"
          />
      </div>
      <div v-else class="flex items-center justify-center py-4">
        <small>No open sessions</small>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import moment from 'moment'

const { t, locale } = useI18n()

const modelSession = defineModel<string|null>('session')
const modelPopup = defineModel<boolean>('popup')

const dataShowBugReport = useState<boolean>('modal-bug', () => false)
const dataSupportLastOnlineInMinutes = ref<number|null>(null)

const dataSessions = ref<Array<{
  session: string
  message: string
  created_at: string
  unread_count: number
}>>([])

onMounted(() => {
  methodShowOpenSessions()
  methodLoadSupportLastOnline()
})

const methodLoadSupportLastOnline = async () => {
  if (((user.value as User)?.is_admin ?? false))
    return

  const lo = await ws.send('support.supportLastOnline');

  dataSupportLastOnlineInMinutes.value = lo < 0
    ? lo * -1
    : lo;
}

const methodTalkToHuman = () => {
  ws.send<{
    session: string
  }>('support.new',{
    visitor_id: visitorId(),
    locale: locale.value
  }).then((r) => {
    modelSession.value = r.session
    console.log('[support] New session',r.session)
  })
}

const methodShowOpenSessions = () => {
  if (!((user.value as User)?.is_admin ?? false))
    return

  ws.send('support.openSessions').then((r) => {
    dataSessions.value = r.sessions
  })
}

watch(modelSession,methodShowOpenSessions)
watch(isAuthed,methodShowOpenSessions)
watch(modelPopup, (v) => {
  if (v){
    methodLoadSupportLastOnline()
    methodShowOpenSessions()
  }
})

defineExpose({
  methodShowOpenSessions
})
</script>
